import { cn } from '@/design-system/lib/cn';
import { Badge } from '@/design-system/ui/Badge';
import type { ScheduleStatus } from '@escala/domain/types';

import { STATUS_META } from './statusMeta';

export type StatusBadgeProps = {
  status: ScheduleStatus;
  /** Texto no lugar do rótulo (ex.: a proporção "6/9"); o rótulo vai para o nome acessível. */
  children?: React.ReactNode;
  /** Só o ícone (celular); o rótulo continua para leitor de tela. */
  iconOnly?: boolean;
  className?: string;
};

/** Pílula do status da escala: sempre ícone + texto (visível ou acessível). */
export default function StatusBadge({ status, children, iconOnly = false, className }: StatusBadgeProps) {
  const meta = STATUS_META[status];
  const Icon = meta.icon;
  const custom = children !== undefined;

  return (
    <Badge tone={status} className={cn(iconOnly && 'px-2', className)}>
      <Icon aria-hidden />
      {iconOnly ? <span className="sr-only">{meta.label}</span> : null}
      {!iconOnly && custom ? (
        <>
          <span className="sr-only">{meta.label}: </span>
          <span data-numeric>{children}</span>
        </>
      ) : null}
      {!iconOnly && !custom ? meta.label : null}
    </Badge>
  );
}
